/* eslint-disable no-useless-catch */
import { serialize } from 'utils/crud';

import { entityService } from './services';
// #endregion Local Imports

const pathname = '/entity-distance-shipping-fees';

export const EntityDistanceShippingFeesApi = {
  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  checkDuplicate: async (
    option?: CheckDuplicateEntityDistanceShippingFeeCodeQuery
  ) => {
    let url = `${pathname}/check-duplicate`;
    const query = serialize(option || {});
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  filter: async (option: EntityDistanceShippingFeeQuery) => {
    let url = `${pathname}/filter`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findToCreateBill: async (
    option: FindEntityDistanceShippingFeeToCreateBillQuery
  ) => {
    let url = `${pathname}/find-to-create-bill`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findToUpdateBill: async (billID: string) => {
    const url = `${pathname}/find-to-update-bill/${billID}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findToUpdateOrder: async (
    orderID: string,
    option?: { isCreateBillCase?: boolean }
  ) => {
    let url = `${pathname}/find-to-update-order/${orderID}`;
    if (option) {
      const query = serialize(option);
      url += query;
    }

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  remove: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface EntityDistanceShippingFeeQuery {
  order?: any;
  page?: number;
  take?: number;
  skip?: number;
  tab?: string;
  reserved?: boolean;
  ownerID?: string;
}

export interface FindEntityDistanceShippingFeeToCreateBillQuery {
  ownerID?: string;
}

export interface CheckDuplicateEntityDistanceShippingFeeCodeQuery {
  code: string;
  ownerID?: string;
}
